import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { clearSearch, search, setFilterSort } from "../../server/Product";
import { useDispatch, useSelector } from "react-redux";
import { Mic, Search as SearchIcon, X, SlidersHorizontal } from "lucide-react";

function isFilterRoute(pathname) {
  return (
    pathname.includes("/category/") ||
    pathname.includes("/search") ||
    pathname.includes("/sales")
  );
}

const Search = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchString = useSelector(
    (state) => state.displayProduct.searchString,
  );
  const [searchStringHear, SetSearchString] = useState(searchString);

  const filterAndSort = useSelector(
    (state) => state.displayProduct?.filterAndSort ?? false,
  );
  const selectedFilters = useSelector(
    (state) => state.displayProduct?.selectedFilters ?? [],
  );
  const sortKey = useSelector(
    (state) => state.displayProduct?.sortKey ?? "relevant",
  );
  const brandIds = useSelector(
    (state) => state.productFilters?.filters?.brandIds ?? [],
  );
  const subBrandIds = useSelector(
    (state) => state.productFilters?.filters?.subBrandIds ?? [],
  );

  const showFilterIcon = isFilterRoute(pathname);
  const hasActiveFilter =
    selectedFilters.length > 0 ||
    brandIds.length > 0 ||
    subBrandIds.length > 0 ||
    sortKey !== "relevant";

  useEffect(() => {
    SetSearchString(searchString);
  }, [searchString]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchStringHear.length >= 2) {
        console.log("searching for", searchStringHear);
        if (pathname !== "/search") navigate("/search");
        dispatch(search(searchStringHear));
      } else {
        if (pathname === "/search") navigate(-1);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
    // Intentionally only re-run on search text + dispatch; pathname/navigate handled inside effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStringHear, dispatch]);

  const handleVoiceSearch = () => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("דפדפן זה אינו תומך בזיהוי דיבור");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "he-IL";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = (event) => {
      const voiceInput = event.results[0][0].transcript;
      SetSearchString(voiceInput);
      dispatch(search(voiceInput));
      if (pathname !== "/search") {
        navigate("/search");
      }
    };

    recognition.onerror = (error) => {
      console.error("שגיאה בזיהוי הדיבור:", error);
    };

    recognition.start();
  };

  return (
    <div className="search-cont">
      {searchStringHear === "" ? (
        <span className="search-icon-static search-cont__lead" aria-hidden>
          <SearchIcon size={18} strokeWidth={2.25} />
        </span>
      ) : (
        <button
          type="button"
          className="search-icon-btn search-icon-btn--clear search-cont__lead"
          aria-label="נקה חיפוש"
          title="נקה חיפוש"
          onClick={() => {
            SetSearchString("");
            dispatch(clearSearch());
          }}
        >
          <X aria-hidden size={18} strokeWidth={2.25} />
        </button>
      )}
      <input
        placeholder="חיפוש מוצר..."
        className="search-cont__input for-search"
        type="search"
        enterKeyHint="search"
        autoComplete="off"
        aria-label="חיפוש מוצר"
        onChange={(e) => SetSearchString(e.target.value)}
        value={searchStringHear}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            dispatch(search(e.target.value));
          }
        }}
      />
      <div className="search-cont__actions">
        <button
          type="button"
          className="search-icon-btn search-icon-btn--mic"
          onClick={handleVoiceSearch}
          aria-label="חיפוש קולי"
          title="חיפוש קולי"
        >
          <Mic aria-hidden size={18} strokeWidth={2} />
        </button>
        {showFilterIcon ? (
          <button
            type="button"
            className={`search-icon-btn search-icon-btn--filter${filterAndSort ? " search-icon-btn--filter-open" : ""}`}
            onClick={() => dispatch(setFilterSort(!filterAndSort))}
            aria-expanded={filterAndSort}
            aria-label="סינון ומיון"
            title="סינון ומיון"
          >
            <SlidersHorizontal aria-hidden size={17} strokeWidth={2} />
            {hasActiveFilter ? (
              <span className="search-filter-dot" aria-hidden />
            ) : null}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default Search;
